<template>
  <div>
            <v-card-title class="body-2 font-weight-bold">
              E-POLIS
            </v-card-title>
            <v-layout>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="form.branchclient_kanwildetail"
                    ref="kanwil"
                    label="Kanwil"
                    class="mx-2"
                    prepend-inner-icon="mdi-account-group"
                    @click="OpenData('kanwil')"
                    :readonly="
                      form.branchclient_login === '00003' ? false : true
                    "
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="form.branchclient_detail"
                    ref="outlet"
                    label="Outlet"
                    class="mx-2"
                    prepend-inner-icon="mdi-map-marker"
                    @click="OpenData('outlet')"
                    :readonly="
                      form.branchclient_login === '00003' ? false : true
                    "
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="form.contractno"
                    ref="contractno"
                    label="No Kontrak"
                    prepend-inner-icon="mdi-ticket-confirmation"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  v-if="form.branchclient_login === '00003'"
                >
                  <v-text-field
                    v-model="form.insured"
                    ref="insured"
                    class="mx-2"
                    label="Nama Peserta"
                    prepend-inner-icon="mdi-account-circle"
                  />
                </v-col>
              </v-row>
            </v-layout>
            <div class="epolis-actions">
              <v-btn
                v-if="form.branchclient_login !== '' || form.contractno !== ''"
                class="epolis-action-btn epolis-action-btn--check"
                depressed
                @click="CheckBatch()"
              >
                <v-icon left>mdi-database-search-outline</v-icon>
                Cek Data
              </v-btn>
              <v-btn
                v-if="
                  (form.branchclient_login !== '' || form.contractno !== '') &&
                    (form.branchclient_login === '00003' ||
                      login_user.substring(0, 9) === 'pgdkanwil')
                "
                class="epolis-action-btn epolis-action-btn--clear"
                depressed
                @click="ClearForm()"
              >
                <v-icon left>mdi-broom</v-icon>
                Clear Form
              </v-btn>
            </div>
            <v-dialog v-model="select.branchclient" hide-overlay fullscreen>
              <v-card>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="fourth" outlined @click="select.branchclient = false">Batal</v-btn>
                </v-card-actions>
                <v-text-field
                  id="filter_branchclient"
                  v-model="search.branchclient"
                  class="mx-2"
                  placeholder="Cari Outlet dan Enter"
                  append-icon="mdi-magnify"
                  @keyup.enter="OpenData('outlet')"
                />
                <v-progress-linear v-if="loading.branchclient" indeterminate color="primary" />
                <v-list two-line class="pt-0">
                  <v-list-item
                    v-for="branch in item.branchclient"
                    :key="branch.branchclient_id"
                    ripple
                    @click="SetData('outlet', branch.branchclient_id, branch.branchclient_name)"
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{ branch.branchclient_id }} - {{ branch.branchclient_name }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="!item.branchclient.length && !loading.branchclient">
                    <v-list-item-content><v-list-item-title>Tidak Ada Data</v-list-item-title></v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-dialog>
            <v-dialog v-model="select.kanwil" hide-overlay fullscreen>
              <v-card>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="fourth" outlined @click="select.kanwil = false">Batal</v-btn>
                </v-card-actions>
                <v-text-field
                  id="filter_kanwil"
                  v-model="search.kanwil"
                  class="mx-2"
                  placeholder="Cari Kanwil dan Enter"
                  append-icon="mdi-magnify"
                  @keyup.enter="OpenData('kanwil')"
                />
                <v-progress-linear v-if="loading.kanwil" indeterminate color="primary" />
                <v-list two-line class="pt-0">
                  <v-list-item
                    v-for="kanwil in item.kanwil"
                    :key="kanwil.branchclient_kanwilid"
                    ripple
                    @click="SetData('kanwil', kanwil.branchclient_kanwilid, kanwil.branchclient_kanwil)"
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{ kanwil.branchclient_kanwilid }} - {{ kanwil.branchclient_kanwil }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="!item.kanwil.length && !loading.kanwil">
                    <v-list-item-content><v-list-item-title>Tidak Ada Data</v-list-item-title></v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-dialog>
            <v-dialog v-model="select.batchsubject" width="820" persistent>
              <v-card>
                <v-card-actions class="primary white--text">
                  {{ form.branchclient_id }} - {{ form.branchclient_name }}
                  <v-spacer></v-spacer>
                  <v-btn color="fourth" outlined @click="select.batchsubject = false">Batal</v-btn>
                </v-card-actions>
                <v-progress-linear v-if="loading.batchsubject" indeterminate color="primary" />
                <v-list two-line class="pt-0">
                  <v-list-item v-for="(subject, index) in item.batchsubject" :key="subject.subject_id">
                    <v-list-item-content><v-list-item-title>{{ subject.subject_id }}</v-list-item-title></v-list-item-content>
                    <v-list-item-action v-if="form.numbers === index">Loading...</v-list-item-action>
                    <v-list-item-action v-else>
                      <v-icon large @click="PrintPDF(index, subject.subject_id, subject.branchclient_id, subject.fastflow_refid)">mdi-file-pdf-box</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                  <v-list-item v-if="!item.batchsubject.length && !loading.batchsubject">
                    <v-list-item-content><v-list-item-title>Tidak Ada Data</v-list-item-title></v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-dialog>
            <v-dialog v-model="select.insured" width="820" persistent>
              <v-card>
                <v-card-actions class="primary">
                  <v-spacer></v-spacer>
                  <v-btn color="fourth" outlined @click="select.insured = false">Batal</v-btn>
                </v-card-actions>
                <v-progress-linear v-if="loading.insured" indeterminate color="primary" />
                <v-list two-line class="pt-0">
                  <v-list-item v-for="(insured, index) in item.insured" :key="insured.fastflow_row">
                    <v-list-item-content>
                      <v-list-item-title>{{ insured.fastflow_refid }} - {{ insured.fastflow_insured }}</v-list-item-title>
                      <v-list-item-subtitle>{{ insured.fastflow_subject }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action v-if="form.numbers === index">Loading...</v-list-item-action>
                    <v-list-item-action v-else>
                      <v-icon large @click="PrintPDF(index, insured.fastflow_subject, insured.fastflow_branchclient, insured.fastflow_refid)">mdi-file-pdf-box</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                  <v-list-item v-if="!item.insured.length && !loading.insured">
                    <v-list-item-content><v-list-item-title>Tidak Ada Data</v-list-item-title></v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-dialog>
            <v-snackbar
              v-model="snackbar.dialog"
              :color="snackbar.color"
              :timeout="snackbar.timeout"
              rounded="pill"
              bottom
            >
              {{ snackbar.text }}
              <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar.dialog = false">Close</v-btn>
              </template>
            </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "AppPgdEpolis",
  data: () => ({
    login_user: "",
    form: {
      branchclient_id: "",
      branchclient_name: "",
      branchclient_login: "",
      numbers: "",
      contractno: "",
      branchclient_kanwilid: "",
      branchclient_kanwilname: "",
      branchclient_kanwildetail: "",
      branchclient_detail: "",
      insured: ""
    },
    item: { branchclient: [], batchsubject: [], kanwil: [], insured: [] },
    select: { branchclient: false, batchsubject: false, kanwil: false, insured: false },
    loading: { branchclient: false, batchsubject: false, kanwil: false, insured: false },
    search: { branchclient: "", kanwil: "" },
    snackbar: { dialog: false, color: "success", text: "", timeout: 3000 }
  }),
  created() {
    this.FirstLoad();
  },
  methods: {
    FirstLoad() {
      const loginId = localStorage.getItem("website_users_id");
      if (loginId === null) {
        window.location.href = "/login";
        return;
      }
      this.login_user = loginId;
      if (loginId === "pegadaian.pusat") {
        this.form.branchclient_login = "00003";
        return;
      }
      const otherId = localStorage.getItem("website_users_otherid") || "";
      const otherName = localStorage.getItem("website_users_othername") || "";
      this.form.branchclient_login = otherId;
      if (otherId === "00003") return;
      if (loginId.substring(0, 9) === "pgdkanwil") {
        this.form.branchclient_kanwilid = otherId;
        this.form.branchclient_kanwilname = otherName;
        this.form.branchclient_kanwildetail = `${otherId} - ${otherName}`;
      } else {
        this.form.branchclient_id = otherId;
        this.form.branchclient_name = otherName;
        this.form.branchclient_detail = `${otherId} - ${otherName}`;
      }
    },
    SnackBar(dialog, color, text, timeout) {
      this.snackbar.dialog = dialog;
      this.snackbar.color = color;
      this.snackbar.text = text;
      this.snackbar.timeout = timeout;
    },
    OpenData(type) {
      if (
        type === "outlet" &&
        (this.form.branchclient_login === "00003" ||
          this.login_user.substring(0, 9) === "pgdkanwil")
      ) {
        this.select.branchclient = true;
        this.item.branchclient = [];
        this.$nextTick(() => {
          const input = document.getElementById("filter_branchclient");
          if (input) input.focus();
        });
        if (this.search.branchclient || this.form.branchclient_kanwilid) {
          this.GetBranchClient();
        }
      } else if (type === "kanwil" && this.form.branchclient_login === "00003") {
        this.select.kanwil = true;
        this.item.kanwil = [];
        this.$nextTick(() => {
          const input = document.getElementById("filter_kanwil");
          if (input) input.focus();
        });
        if (this.search.kanwil) this.GetKanwil();
      }
    },
    GetBranchClient() {
      this.loading.branchclient = true;
      const formData = new FormData();
      formData.append("datavalue", this.search.branchclient);
      formData.append("branchclient_kanwilid", this.form.branchclient_kanwilid);
      formData.append("branchclient_group", "PEGADAIAN");
      formData.append("order_by", "branchclient_id");
      formData.append("order_type", "ASC");
      this.$axios
        .post(this.$functions.SafeURL("apiListBranchClient", ""), formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => { this.item.branchclient = response.data; })
        .catch(error => this.SnackBar(true, "error", error.message, 3000))
        .finally(() => { this.loading.branchclient = false; });
    },
    GetKanwil() {
      this.loading.kanwil = true;
      const formData = new FormData();
      formData.append("datavalue", this.search.kanwil);
      formData.append("order_by", "branchclient_mergeid");
      formData.append("order_type", "ASC");
      this.$axios
        .post(this.$functions.SafeURL("apiListBranchClientKanwil", ""), formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => { this.item.kanwil = response.data; })
        .catch(error => this.SnackBar(true, "error", error.message, 3000))
        .finally(() => { this.loading.kanwil = false; });
    },
    SetData(type, id, description) {
      if (type === "outlet") {
        this.form.branchclient_id = id;
        this.form.branchclient_name = description;
        this.form.branchclient_detail = `${id} - ${description}`;
        this.select.branchclient = false;
        this.CheckBatch();
      } else if (type === "kanwil") {
        this.form.branchclient_kanwilid = id;
        this.form.branchclient_kanwilname = description;
        this.form.branchclient_kanwildetail = `${id} - ${description}`;
        this.select.kanwil = false;
        this.OpenData("outlet");
      }
    },
    CheckBatch() {
      if (this.form.insured) {
        this.select.insured = true;
        this.loading.insured = true;
        const formData = new FormData();
        formData.append("fastflow_insured", this.form.insured);
        formData.append("fastflow_inquiry", "PEGADAIAN");
        formData.append("fastflow_group", "PEGADAIAN");
        this.$axios
          .post(this.$functions.SafeURL("apiListFastFlow", ""), formData, {
            headers: { "Content-Type": "multipart/form-data" }
          })
          .then(response => {
            const feedback = response.data;
            if (feedback.length > 0 && feedback[0].feedback !== "Y") {
              this.SnackBar(true, "error", feedback[0].feedback, 0);
            } else {
              this.item.insured = feedback;
            }
          })
          .catch(error => this.SnackBar(true, "error", error.message, 3000))
          .finally(() => { this.loading.insured = false; });
        return;
      }
      this.select.batchsubject = true;
      this.loading.batchsubject = true;
      const formData = new FormData();
      formData.append("fastflow_refid", this.form.contractno);
      formData.append("fastflow_branchclient", this.form.branchclient_id);
      formData.append("fastflow_branchkanwil", this.form.branchclient_kanwilid);
      formData.append("fastflow_group", "PEGADAIAN");
      this.$axios
        .post(this.$functions.SafeURL("apiListFastflowSubject", ""), formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => {
          const feedback = response.data;
          if (feedback.length > 0 && feedback[0].feedback !== "Y") {
            this.SnackBar(true, "error", feedback[0].feedback, 0);
          } else {
            if (feedback.length > 0) {
              this.form.branchclient_id = feedback[0].branchclient_id;
              this.form.branchclient_name = feedback[0].branchclient_name;
              this.form.branchclient_detail = `${feedback[0].branchclient_id} - ${feedback[0].branchclient_name}`;
            }
            this.item.batchsubject = feedback;
          }
        })
        .catch(error => this.SnackBar(true, "error", error.message, 3000))
        .finally(() => { this.loading.batchsubject = false; });
    },
    PrintPDF(index, id, branchClient, refId = "") {
      this.form.numbers = index;
      const formData = new FormData();
      formData.append("fastflow_branchclient", branchClient);
      formData.append("fastflow_branchkanwil", this.form.branchclient_kanwilid);
      formData.append("fastflow_subject", id);
      formData.append("fastflow_refid", refId || this.form.contractno || "");
      this.$axios
        .post(this.$functions.SafeURL("apiListFastflowPrintSubject", ""), formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => {
          const feedback = response.data;
          if (feedback.length > 0 && feedback[0].feedback === "Y") {
            window.open(feedback[0].subject_url, "_blank");
          } else {
            this.SnackBar(
              true,
              "error",
              feedback.length ? feedback[0].feedback : "No Data Found",
              3000
            );
          }
        })
        .catch(error => this.SnackBar(true, "error", error.message, 3000))
        .finally(() => { this.form.numbers = ""; });
    },
    ClearForm() {
      this.form.branchclient_id = "";
      this.form.branchclient_name = "";
      this.form.branchclient_detail = "";
      if (this.form.branchclient_login === "00003") {
        this.form.branchclient_kanwilid = "";
        this.form.branchclient_kanwilname = "";
        this.form.branchclient_kanwildetail = "";
      }
      this.form.contractno = "";
      this.form.insured = "";
    }
  }
};
</script>

<style scoped>
.epolis-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 4px 8px 14px;
  padding: 12px;
  border: 1px solid rgba(255, 255, 255, 0.72);
  border-radius: 16px;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.58),
    rgba(228, 239, 249, 0.34)
  );
  box-shadow: 0 10px 26px rgba(24, 45, 82, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(14px) saturate(145%);
  -webkit-backdrop-filter: blur(14px) saturate(145%);
}

.epolis-action-btn {
  min-width: 148px !important;
  height: 44px !important;
  padding: 0 20px !important;
  border: 1px solid rgba(255, 255, 255, 0.42) !important;
  border-radius: 13px !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  letter-spacing: 0.04em !important;
  text-transform: none !important;
  box-shadow: 0 8px 18px rgba(19, 42, 78, 0.18),
    inset 0 1px 0 rgba(255, 255, 255, 0.24) !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease,
    filter 0.2s ease !important;
}

.epolis-action-btn--check {
  color: #ffffff !important;
  background: linear-gradient(
    135deg,
    rgba(255, 126, 39, 0.96),
    rgba(235, 83, 27, 0.9)
  ) !important;
}

.epolis-action-btn--clear {
  color: #ffffff !important;
  background: linear-gradient(
    135deg,
    rgba(10, 153, 165, 0.94),
    rgba(0, 105, 131, 0.9)
  ) !important;
}

.epolis-action-btn:hover {
  filter: brightness(1.06);
  transform: translateY(-2px);
  box-shadow: 0 13px 24px rgba(19, 42, 78, 0.24),
    inset 0 1px 0 rgba(255, 255, 255, 0.32) !important;
}

.epolis-action-btn:active {
  transform: translateY(0) scale(0.98);
}

.epolis-action-btn:focus-visible {
  outline: 3px solid rgba(51, 130, 246, 0.3);
  outline-offset: 3px;
}

@media (max-width: 600px) {
  .epolis-action-btn {
    flex: 1 1 100%;
  }
}
</style>

